import { CircularProgress } from "@material-ui/core";

export const Loading = () => {
  return <CircularProgress />;
};
